// Auto-generated by tools/scripts/generate-version.mjs — do not edit.
// Regenerated before every build; local values are placeholders.
export const APP_VERSION = '1.0.0-beta.229';
export const APP_COMMIT = '80b39e24';
export const APP_BUILD_DATE = '2026-11-04';
